module.exports = __webpack_public_path__ + "assets/icon-face-neutral-component.41beeb88.svg";